import axios from "axios";
import { service_url, cookieValue, URLJoin } from "./const";

async function RestGet(route_path) {
  let full_url = URLJoin(service_url, route_path);
  let result = [];

  const config = {
    headers: {
      cookie: cookieValue,
      "content-type": "application/json;charset=UTF-8",
    },
  };
  try {
    const response = await axios.get(full_url, config);
    result = response.data;
  } catch (exc) {
    console.log(exc);
  }
  return result;
}

export default RestGet;
